module.exports = __webpack_public_path__ + "static/media/category2.6e9ffb61.svg";